export const DEFAULT_CONTENT = {
  nav_solutions: "Solutions",
  nav_templates: "Templates",
  nav_api: "API",
  nav_pricing: "Pricing",
  nav_contact: "Contact Us",
  nav_upscale: "Upscale 4K",
  nav_login: "Login",
  nav_trial: "Start Free Trial",
  hero_explore: "Explore Templates",

  hero_title: "Maximize revenue from",
  hero_highlight: "iris photography",
  hero_subtitle: "First fully automated AI iris editing platform",
  hero_card1: "30-second iris editing",
  hero_card2: "Free art generation",
  hero_demo_label: "Watch Demo",
  hero_cta: "Start Free Trial",

  benefits_title: "Reduce your editing time by",
  benefits_highlight: "90%",
  benefits_subtitle: "From RAW eye photo to print-ready iris in 30 seconds.",

  features_title: "Powerful Automated Features",

  templates_title: "Create iris art",
  templates_highlight: "for free",
  templates_subtitle: "Automatically generate art effects, ready to print and sell in seconds.",
  templates_gallery_title: "Explore our art templates",
  templates_gallery_subtitle: "Choose from dozens of professionally designed templates that automatically transform your iris photos into stunning art pieces.",

  uniqueness_title: "Sell iris",
  uniqueness_highlight: "uniqueness report",
  uniqueness_subtitle: "Offer what every customer is curious about — and willing to pay for.",

  pricing_eyebrow: "Planes mensuales",
  pricing_title: "Suscripción",
  pricing_highlight: "profesional",
  pricing_subtitle: "Recibe tus ediciones cada mes automáticamente. Cancela cuando quieras.",
  starter_name: "Starter",
  starter_desc: "Ideal para empezar. 30 ediciones cada mes.",
  starter_feature: "30 ediciones al mes",
  studio_pro_name: "Studio Pro",
  studio_pro_desc: "Para estudios con volumen. 80 ediciones cada mes.",
  studio_pro_feature: "80 ediciones al mes",
  advanced_name: "Studio Avanzado",
  advanced_desc: "Plan a medida para franquicias y grandes volúmenes.",
  advanced_feature: "Volumen personalizado · franquicia",
  starter_price: "29",
  studio_pro_price: "80",
  advanced_price: "A medida",
  crm_name: "CRM para Estudios",
  crm_desc: "Controla todos tus clientes, envíos y seguimiento en un solo lugar. Pensado para estudios de fotografía de iris.",
  crm_feature: "Gestión de clientes y envíos",
  crm_price: "39",
  crm_section_title: "Controla tu estudio con nuestro",
  crm_section_highlight: "CRM",
  crm_section_subtitle: "Todos tus clientes, envíos y seguimiento en un solo lugar. Diseñado para estudios de fotografía de iris.",
  crmb1_icon: "Users",
  crmb1_title: "Control total de clientes",
  crmb1_desc: "Ficha completa de cada cliente: historial, pedidos y notas, siempre a mano.",
  crmb2_icon: "Send",
  crmb2_title: "Envíos automáticos",
  crmb2_desc: "Programa y gestiona los envíos de tus trabajos sin perder ningún pedido.",
  crmb3_icon: "Bell",
  crmb3_title: "Recordatorios y seguimiento",
  crmb3_desc: "Avisos automáticos de citas, entregas y renovaciones para no olvidar nada.",
  crmb4_icon: "BarChart3",
  crmb4_title: "Informes y ventas",
  crmb4_desc: "Analiza ingresos, clientes recurrentes y el rendimiento de tu estudio.",
  crm_section_cta: "Ver planes del CRM",
  bots_title: "Bots de texto para tu",
  bots_highlight: "página web",
  bots_subtitle: "Atención 24/7 que responde al instante, capta clientes y aumenta tus ventas — de forma automática.",
  botb1_icon: "Clock",
  botb1_title: "Atención 24/7",
  botb1_desc: "Responde a tus visitantes al instante, a cualquier hora, sin colas ni esperas. Nunca pierdes una consulta.",
  botb2_icon: "Users",
  botb2_title: "Capta más clientes",
  botb2_desc: "Recoge nombre, email y teléfono de forma natural durante la conversación y los envía directo a tu CRM.",
  botb3_icon: "TrendingUp",
  botb3_title: "Más ventas y conversiones",
  botb3_desc: "Guía al cliente paso a paso hacia la compra. La IA conversacional puede aumentar las conversiones hasta un 35%.",
  botb4_icon: "Zap",
  botb4_title: "Ahorra tiempo y costes",
  botb4_desc: "Automatiza las preguntas frecuentes y reduce los tiempos de respuesta hasta un 90%, liberando a tu equipo.",
  bots_stat1_num: "24/7",
  bots_stat1_label: "Disponibilidad total",
  bots_stat2_num: "+35%",
  bots_stat2_label: "Más conversiones",
  bots_stat3_num: "-90%",
  bots_stat3_label: "Tiempo de respuesta",
  bots_cta: "Quiero mi bot de texto",
  bots_price: "49,99",
  bots_plan_name: "Bot de texto",
  bots_plan_f1: "Conversaciones ilimitadas",
  bots_plan_f2: "Derivación al equipo por email",
  bots_plan_f3: "Más de 20 idiomas",

  more_title: "There is",
  more_highlight: "MORE!",
  more_subtitle: "Powerful features to scale your iris photography business",

  feat1_title: "Precise Iris Cropping",
  feat1_desc: "Perfectly isolates the iris with our intelligent boundary detection.",
  feat2_title: "Reflection Removal",
  feat2_desc: "Automatically eliminates light reflections that distort iris detail.",
  feat3_title: "Eyelash Cleaning",
  feat3_desc: "Cleanly removes eyelashes that obstruct the iris pattern.",
  features_cta: "Start Free Trial",

  artben1_icon: "Sparkles",
  artben1_title: "Premium Art",
  artben1_desc: "Create multiple art effects at once",
  artben2_icon: "TrendingUp",
  artben2_title: "Increase Revenue",
  artben2_desc: "Increase average order value per customer",
  artben3_icon: "ScanLine",
  artben3_title: "High Resolution",
  artben3_desc: "300 DPI print-ready art",
  tpl1_title: "Eternal Love",
  tpl1_desc: "Your iris elegantly framed within a romantic heart shape.",
  tpl2_title: "Infinite Bond",
  tpl2_desc: "Endless connection symbolized by the timeless infinity loop.",
  tpl3_title: "Aquatic Flow",
  tpl3_desc: "Dynamic water effects creating a fluid, mesmerizing composition.",
  tpl4_title: "Harmony Balance",
  tpl4_desc: "Perfect balance and unity through the ancient symbol of harmony.",
  templates_cta: "View All Art Templates",

  score_title: "Iris Uniqueness Score",
  score_desc: "A 0-100 score showing how rare and unique the iris is",
  score_badge: "Rare",
  score_scale: "Common\nModerate\nRare\nUnique",
  anat1_title: "Crypt",
  anat1_desc: "Open spaces in the iris stroma that create unique patterns.",
  anat2_title: "Collarette",
  anat2_desc: "The inner border of the iris, often forming distinctive rings.",
  anat3_title: "Freckle",
  anat3_desc: "Pigmented spots that add character and uniqueness to the iris.",
  anat4_title: "Radial Furrow",
  anat4_desc: "Lines radiating from the pupil, creating distinctive patterns.",
  uniqueness_cta: "Read More About Iris Analysis",

  mf1_icon: "Mail",
  mf1_title: "Custom Email Templates",
  mf1_desc: "Automate customer communication with branded email templates. Send professional, personalized emails automatically.",
  mf1_bullets: "Branded templates\nAutomated sending\nSave time",
  mf2_icon: "Code2",
  mf2_title: "API Integration",
  mf2_desc: "Integrate Eye.Photo directly into your existing workflow with our powerful API. Automate your entire photo processing pipeline.",
  mf2_bullets: "RESTful API access\nWorkflow automation\nCustom integrations",
  mf2_link: "Learn more",
  mf3_icon: "Plug",
  mf3_title: "Third-Party Integrations",
  mf3_desc: "Connect with your favorite tools. Mailchimp integration and more to streamline your business operations.",
  mf3_bullets: "Mailchimp integration\nCRM connectivity\nWorkflow automation",
  mf3_link: "View plans",
  mf4_icon: "Building2",
  mf4_title: "Franchise Management",
  mf4_desc: "Manage multiple locations, track performance, and scale your iris photography franchise with powerful analytics and tools.",
  mf4_bullets: "Multi-location management\nFranchise analytics\nPerformance tracking",
  mf4_link: "Contact sales",
  more_cta: "Start Free Trial",

  upscale_eyebrow: "New · AI",
  upscale_title: "Upscale your photos to",
  upscale_highlight: "4K in one click",
  upscale_subtitle: "Turn any iris photo into an ultra-sharp 4K image with AI. Drag the bar to see the difference.",
  upscale_cta: "Try 4K upscaling — free",

  contact_title: "Ready to",
  contact_highlight: "scale your business?",
  contact_subtitle: "Join hundreds of iris photographers saving time and increasing revenue.",
  owner_email: "ventas@irisfullcolorvalencia.com",
  owner_phone: "+34 960730749",
};
